module.exports = __webpack_public_path__ + "static/hand-197b7daaf3424dc6021d4fdc2747cc26.png";